// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__WeK4z","rootSuccess":"CompleteLink_rootSuccess__2Ilyv","rootFailure":"CompleteLink_rootFailure__BqsCy","isDisabled":"CompleteLink_isDisabled__1gaqT"};